import { render, staticRenderFns } from "./GenericItemModal.vue?vue&type=template&id=e53c7a8a&scoped=true"
import script from "./GenericItemModal.vue?vue&type=script&lang=js"
export * from "./GenericItemModal.vue?vue&type=script&lang=js"
import style0 from "./GenericItemModal.vue?vue&type=style&index=0&id=e53c7a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53c7a8a",
  null
  
)

export default component.exports